import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { ListProps } from "@/types";


/**
 * A generic list component.
 */
const __default__ = {
  name: "List",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    bordered: { type: Boolean },
    scrollHeight: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createBlock(_component_q_list, {
    bordered: props.bordered
  }, {
    default: _withCtx(() => [
      (!!props.scrollHeight)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "scrollable",
            style: _normalizeStyle(`max-height: ${props.scrollHeight}px`)
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 4))
        : _renderSlot(_ctx.$slots, "default", { key: 1 })
    ]),
    _: 3
  }, 8, ["bordered"]))
}
}

})